export default __webpack_public_path__ + "static/media/img-0243-australia-half-face.052edec6.png";